import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Navigation, Pagination, Scrollbar } from "swiper/modules";
import type { Swiper as SwiperClass } from "swiper/types";
import { FC } from "react";
import { ProfitRealizedInfo } from "./ProfitRealizedInfo";
import { APP_ID } from "../../../../_app/consts";
import { useTranslation } from "react-i18next";

interface ProfitInfoSliderProps {
  totalProfit: number;
  realizedPnl: number;
  gridPnl: number;
}

const ProfitInfoSlider: FC<ProfitInfoSliderProps> = ({ totalProfit, realizedPnl, gridPnl }) => {
  const initialSlideIndex = Number(localStorage.getItem("activeSlide" + APP_ID)) || 0;

  const { t } = useTranslation("bots");

  return (
    <Swiper
      initialSlide={initialSlideIndex}
      cssMode={false}
      style={{ height: "119px" }}
      direction="vertical"
      spaceBetween={16}
      slidesPerView={1}
      loop={true}
      freeMode={false}
      pagination={{ clickable: true }}
      scrollbar={false}
      onRealIndexChange={(swiper: SwiperClass) => {
        localStorage.setItem("activeSlide" + APP_ID, swiper.realIndex.toString());
      }}
      modules={[Navigation, Pagination, Scrollbar]}
    >
      <SwiperSlide>
        <ProfitRealizedInfo label={t("realizedPnl")} value={realizedPnl} />
      </SwiperSlide>
      <SwiperSlide>
        <ProfitRealizedInfo label={t("gridProfit")} value={gridPnl} />
      </SwiperSlide>
      <SwiperSlide>
        <ProfitRealizedInfo label={t("totalPnl")} value={totalProfit} />
      </SwiperSlide>
    </Swiper>
  );
};

export default ProfitInfoSlider;
